<nav class="navbar fixed-top navbar-expand-lg bg-white border-bottom">
    <div class="container">
        <a class="navbar-brand p-0" [routerLink]="['/']"><img class="pr-3" src="assets/img/logo.jpg"></a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent" aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <i class="fas fa-bars"></i>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto mt-lg-0">
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/forindividual']" routerLinkActive="active-link">For Individual</a>
                </li>
                <li class="nav-item">
                    <a class="nav-link" [routerLink]="['/partner']" routerLinkActive="active-link">Become a Partner</a>
                </li>
                <li class="nav-item resources-header">
                    <a class="nav-link" [routerLink]="['/resources']" routerLinkActive="active-link">Resources</a>
                    <div class="dropdown-content dropdown-resources">
                        <a *ngFor="let m of menuList" (click)="navigateResource(m)">{{m.name}}</a>
                      </div>
                </li>
                <li class="nav-item events-header">
                    <a class="nav-link" [routerLink]="['/events']" routerLinkActive="active-link">Events</a>
                    <!-- <div class="dropdown-content events-dropdown">
                        <a [routerLink]="['/webinar']">Webinar</a>
                      </div> -->
                </li>
                
            </ul>
            <ul class="d-flex d-inline align-content-center my-lg-0 my-sm-2">
                <!-- Login / register -->
                <!--<a class="align-self-center mr-2 text-white text-dark">Sign In</a>-->
                <a class="align-self-center text-white nav-link" [routerLink]="['/contact']" routerLinkActive="active-link">Contact Us</a>
                <a href="https://app.omnicoe.com" id="sign-in"
                    class="align-self-center mr-3 text-white nav-link">Sign In</a>
                <a [routerLink]="['/schedule-demo']"
                    class="bg-button btn btn-primary flex-grow-1 schedule-demo-btn mob-hide">Schedule a Demo</a>

            </ul>
        </div>
    </div>
</nav>